import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IpoApiService } from '@ip-only/front-end-library';
import { environment } from '../../../../environments/environment';
import { DuctData } from '../../span-progress-entities';

@Injectable({ providedIn: 'root' })
export class DuctApiService implements IpoApiService<DuctData> {
  constructor(private readonly http: HttpClient) {}

  fetchSingle(ifs: string) {
    return this.http.get<DuctData>(
      `${environment.spanProgressApiUrl}/ducts/${ifs}`,
    );
  }
}
